import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { isExpandedDialogSelector } from '../selectors'

export function useIsDialogExpanded(pathInTree: string) {
  return useSelector<RootState, boolean>(state => isExpandedDialogSelector(state, pathInTree))
}
